import type { Lead, FollowUp, Customer } from '@/api/types'

/**
 * CRM 线索 + 跟进 + 学员 Mock 数据 (CRM-01)
 * K4决策: 主顾问+协作人+公共池，30天无跟进自动回收
 */

export const mockLeads: Lead[] = [
  {
    id: 'ld-001',
    brandId: 'b-001',
    campusId: 'c-001',
    name: '赵小明',
    phone: '13900000001',
    source: 'REFERRAL',
    status: 'NEW',
    consultantId: '',
    consultantName: '',
    lastFollowUpAt: null,
    convertedCustomerId: null,
    tags: ['高意向', '老带新'],
    note: '朋友推荐，意向较高，尽快联系',
    createdAt: '2025-10-20T09:00:00+08:00',
    updatedAt: '2025-10-20T09:00:00+08:00',
    createdBy: 'system',
    updatedBy: 'system',
  },
  {
    id: 'ld-002',
    brandId: 'b-001',
    campusId: 'c-002',
    name: '钱小华',
    phone: '13900000002',
    source: 'WALK_IN',
    status: 'ASSIGNED',
    consultantId: 'u-consultant-001',
    consultantName: '王顾问',
    lastFollowUpAt: '2025-10-18T14:00:00+08:00',
    convertedCustomerId: null,
    tags: ['试听满意'],
    latestFollowUpContent: '学员到店，试听了一节篮球课，表示满意，正在考虑报名。',
    note: '',
    createdAt: '2025-10-15T10:30:00+08:00',
    updatedAt: '2025-10-18T14:00:00+08:00',
    createdBy: 'u-principal-001',
    updatedBy: 'u-consultant-001',
  },
  {
    id: 'ld-003',
    brandId: 'b-001',
    campusId: 'c-001',
    name: '孙莉',
    phone: '13900000003',
    source: 'ONLINE',
    status: 'FOLLOWING',
    consultantId: 'u-consultant-001',
    consultantName: '王顾问',
    lastFollowUpAt: '2025-10-19T16:00:00+08:00',
    convertedCustomerId: null,
    tags: ['线上咨询', '周末班'],
    latestFollowUpContent: '电话回访，学员还在考虑中，需要在周末前再次跟进。',
    note: '周末班意向明确，关注价格',
    createdAt: '2025-10-10T11:00:00+08:00',
    updatedAt: '2025-10-19T16:00:00+08:00',
    createdBy: 'system',
    updatedBy: 'u-consultant-001',
  },
  {
    id: 'ld-004',
    brandId: 'b-001',
    campusId: 'c-003',
    name: '周强',
    phone: '13900000004',
    source: 'CALL',
    status: 'FOLLOWING',
    consultantId: 'u-principal-001',
    consultantName: '李校长',
    lastFollowUpAt: '2025-09-15T10:00:00+08:00',
    convertedCustomerId: null,
    tags: ['电销'],
    latestFollowUpContent: '初次电话联系，学员表示对私教课程感兴趣，需进一步沟通时间。',
    note: '',
    createdAt: '2025-09-01T08:00:00+08:00',
    updatedAt: '2025-09-15T10:00:00+08:00',
    createdBy: 'system',
    updatedBy: 'u-principal-001',
  },
  {
    id: 'ld-005',
    brandId: 'b-001',
    campusId: 'c-002',
    name: '吴婷婷',
    phone: '13900000005',
    source: 'EVENT',
    status: 'CONVERTED',
    consultantId: 'u-consultant-001',
    consultantName: '王顾问',
    lastFollowUpAt: '2025-10-05T15:00:00+08:00',
    convertedCustomerId: 'cu-001',
    tags: ['活动转化', '篮球'],
    latestFollowUpContent: '学员参加活动后到店，试听了篮球课，现场签约转化。',
    note: '已转化，篮球班年度会员',
    createdAt: '2025-09-20T13:00:00+08:00',
    updatedAt: '2025-10-05T15:00:00+08:00',
    createdBy: 'system',
    updatedBy: 'u-consultant-001',
  },
  {
    id: 'ld-006',
    brandId: 'b-001',
    campusId: 'c-001',
    name: '郑大海',
    phone: '13900000006',
    source: 'OTHER',
    status: 'NEW',
    consultantId: '',
    consultantName: '',
    lastFollowUpAt: null,
    convertedCustomerId: null,
    tags: [],
    note: '',
    createdAt: '2025-10-22T08:30:00+08:00',
    updatedAt: '2025-10-22T08:30:00+08:00',
    createdBy: 'system',
    updatedBy: 'system',
  },
  {
    id: 'ld-007',
    brandId: 'b-001',
    campusId: 'c-003',
    name: '王芳',
    phone: '13900000007',
    source: 'REFERRAL',
    status: 'ASSIGNED',
    consultantId: 'u-principal-001',
    consultantName: '李校长',
    lastFollowUpAt: '2025-10-17T11:00:00+08:00',
    convertedCustomerId: null,
    tags: ['朋友推荐', '一对一'],
    latestFollowUpContent: '微信跟进，学员对一对一私教感兴趣，约下周面谈。',
    note: '一对一私教需求，预算较高',
    createdAt: '2025-10-12T09:00:00+08:00',
    updatedAt: '2025-10-17T11:00:00+08:00',
    createdBy: 'system',
    updatedBy: 'u-principal-001',
  },
  {
    id: 'ld-008',
    brandId: 'b-001',
    campusId: 'c-002',
    name: '冯杰',
    phone: '13900000008',
    source: 'WALK_IN',
    status: 'RECYCLED',
    consultantId: '',
    consultantName: '',
    lastFollowUpAt: '2025-08-10T14:00:00+08:00',
    convertedCustomerId: null,
    tags: ['超30天未跟进'],
    latestFollowUpContent: '微信跟进无回复，标记为回收。',
    note: '长期未跟进已回收，需重新分配',
    createdAt: '2025-08-01T10:00:00+08:00',
    updatedAt: '2025-09-10T00:00:00+08:00',
    createdBy: 'system',
    updatedBy: 'system',
  },
  {
    id: 'ld-009',
    brandId: 'b-001',
    campusId: 'c-001',
    name: '陈雨',
    phone: '13900000009',
    source: 'ONLINE',
    status: 'FOLLOWING',
    consultantId: 'u-consultant-001',
    consultantName: '王顾问',
    lastFollowUpAt: '2025-10-21T09:30:00+08:00',
    convertedCustomerId: null,
    tags: ['小程序', '游泳'],
    latestFollowUpContent: '短信提醒学员查看课程安排，学员回复表示本周内到店。',
    note: '游泳课程，小程序来源',
    createdAt: '2025-10-18T15:00:00+08:00',
    updatedAt: '2025-10-21T09:30:00+08:00',
    createdBy: 'system',
    updatedBy: 'u-consultant-001',
  },
  {
    id: 'ld-010',
    brandId: 'b-001',
    campusId: 'c-003',
    name: '褚卫国',
    phone: '13900000010',
    source: 'CALL',
    status: 'NEW',
    consultantId: '',
    consultantName: '',
    lastFollowUpAt: null,
    convertedCustomerId: null,
    tags: ['电销名单'],
    note: '',
    createdAt: '2025-10-23T08:00:00+08:00',
    updatedAt: '2025-10-23T08:00:00+08:00',
    createdBy: 'system',
    updatedBy: 'system',
  },
  {
    id: 'ld-011',
    brandId: 'b-001',
    campusId: 'c-002',
    name: '卫思齐',
    phone: '13900000011',
    source: 'EVENT',
    status: 'FOLLOWING',
    consultantId: 'u-consultant-001',
    consultantName: '王顾问',
    lastFollowUpAt: '2025-10-16T17:00:00+08:00',
    convertedCustomerId: null,
    tags: ['体验课', '体能'],
    latestFollowUpContent: '体验课后家长表示满意，正在考虑报名体能套餐。',
    note: '体能体验课后意向明显',
    createdAt: '2025-10-08T12:00:00+08:00',
    updatedAt: '2025-10-16T17:00:00+08:00',
    createdBy: 'system',
    updatedBy: 'u-consultant-001',
  },
  {
    id: 'ld-012',
    brandId: 'b-001',
    campusId: 'c-001',
    name: '蒋红',
    phone: '13900000012',
    source: 'OTHER',
    status: 'CONVERTED',
    consultantId: 'u-principal-001',
    consultantName: '李校长',
    lastFollowUpAt: '2025-10-01T10:00:00+08:00',
    convertedCustomerId: 'cu-002',
    tags: ['年度会员'],
    latestFollowUpContent: '学员确认报名年度会员，现场签约并办卡。',
    note: '已转化，年度会员',
    createdAt: '2025-09-05T09:00:00+08:00',
    updatedAt: '2025-10-01T10:00:00+08:00',
    createdBy: 'system',
    updatedBy: 'u-principal-001',
  },
]

export const mockFollowUps: FollowUp[] = [
  {
    id: 'fu-001',
    leadId: 'ld-002',
    staffId: 'u-consultant-001',
    staffName: '王顾问',
    method: 'CALL',
    content: '电话沟通，学员对篮球班感兴趣，约定周末到店咨询。',
    nextFollowUpAt: '2025-10-18T14:00:00+08:00',
    createdAt: '2025-10-16T10:00:00+08:00',
    updatedAt: '2025-10-16T10:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
  {
    id: 'fu-002',
    leadId: 'ld-002',
    staffId: 'u-consultant-001',
    staffName: '王顾问',
    method: 'VISIT',
    content: '学员到店，试听了一节篮球课，表示满意，正在考虑报名。',
    nextFollowUpAt: '2025-10-22T14:00:00+08:00',
    fileUrl: '/uploads/follow-up/ld-002-试听反馈.jpg',
    fileName: '试听反馈.jpg',
    createdAt: '2025-10-18T14:00:00+08:00',
    updatedAt: '2025-10-18T14:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
  {
    id: 'fu-003',
    leadId: 'ld-003',
    staffId: 'u-consultant-001',
    staffName: '王顾问',
    method: 'WECHAT',
    content: '微信沟通，发了课程介绍和价格表，学员表示周末再来咨询。',
    nextFollowUpAt: '2025-10-20T10:00:00+08:00',
    createdAt: '2025-10-15T16:00:00+08:00',
    updatedAt: '2025-10-15T16:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
  {
    id: 'fu-004',
    leadId: 'ld-003',
    staffId: 'u-consultant-001',
    staffName: '王顾问',
    method: 'CALL',
    content: '电话回访，学员还在考虑中，需要在周末前再次跟进。',
    nextFollowUpAt: '2025-10-21T10:00:00+08:00',
    createdAt: '2025-10-19T16:00:00+08:00',
    updatedAt: '2025-10-19T16:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
  {
    id: 'fu-005',
    leadId: 'ld-004',
    staffId: 'u-principal-001',
    staffName: '李校长',
    method: 'CALL',
    content: '初次电话联系，学员表示对私教课程感兴趣，需进一步沟通时间。',
    nextFollowUpAt: '2025-09-20T10:00:00+08:00',
    createdAt: '2025-09-15T10:00:00+08:00',
    updatedAt: '2025-09-15T10:00:00+08:00',
    createdBy: 'u-principal-001',
    updatedBy: 'u-principal-001',
  },
  {
    id: 'fu-006',
    leadId: 'ld-005',
    staffId: 'u-consultant-001',
    staffName: '王顾问',
    method: 'VISIT',
    content: '学员参加活动后到店，试听了篮球课，现场签约转化。',
    nextFollowUpAt: null,
    fileUrl: '/uploads/follow-up/ld-005-签约照片.jpg',
    fileName: '签约照片.jpg',
    createdAt: '2025-10-05T15:00:00+08:00',
    updatedAt: '2025-10-05T15:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
  {
    id: 'fu-007',
    leadId: 'ld-007',
    staffId: 'u-principal-001',
    staffName: '李校长',
    method: 'WECHAT',
    content: '微信跟进，学员对一对一私教感兴趣，约下周面谈。',
    nextFollowUpAt: '2025-10-22T11:00:00+08:00',
    createdAt: '2025-10-17T11:00:00+08:00',
    updatedAt: '2025-10-17T11:00:00+08:00',
    createdBy: 'u-principal-001',
    updatedBy: 'u-principal-001',
  },
  {
    id: 'fu-008',
    leadId: 'ld-009',
    staffId: 'u-consultant-001',
    staffName: '王顾问',
    method: 'MESSAGE',
    content: '短信提醒学员查看课程安排，学员回复表示本周内到店。',
    nextFollowUpAt: '2025-10-23T10:00:00+08:00',
    createdAt: '2025-10-21T09:30:00+08:00',
    updatedAt: '2025-10-21T09:30:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
  {
    id: 'fu-009',
    leadId: 'ld-004',
    staffId: 'u-principal-001',
    staffName: '李校长',
    method: 'CALL',
    content: '二次电话回访，学员对私教时间有疑问，需协调周末时段。',
    nextFollowUpAt: '2025-09-25T10:00:00+08:00',
    createdAt: '2025-09-20T10:00:00+08:00',
    updatedAt: '2025-09-20T10:00:00+08:00',
    createdBy: 'u-principal-001',
    updatedBy: 'u-principal-001',
  },
  {
    id: 'fu-010',
    leadId: 'ld-005',
    staffId: 'u-consultant-001',
    staffName: '王顾问',
    method: 'WECHAT',
    content: '活动前微信提醒学员参加体验课，学员确认到场。',
    nextFollowUpAt: '2025-10-05T15:00:00+08:00',
    createdAt: '2025-10-03T10:00:00+08:00',
    updatedAt: '2025-10-03T10:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
  {
    id: 'fu-011',
    leadId: 'ld-007',
    staffId: 'u-principal-001',
    staffName: '李校长',
    method: 'CALL',
    content: '电话确认面谈时间，学员约下周五到店详谈。',
    nextFollowUpAt: '2025-10-24T11:00:00+08:00',
    createdAt: '2025-10-20T11:00:00+08:00',
    updatedAt: '2025-10-20T11:00:00+08:00',
    createdBy: 'u-principal-001',
    updatedBy: 'u-principal-001',
  },
  {
    id: 'fu-012',
    leadId: 'ld-009',
    staffId: 'u-consultant-001',
    staffName: '王顾问',
    method: 'VISIT',
    content: '学员到店咨询游泳课程，详细介绍了课程安排和价格。',
    nextFollowUpAt: '2025-10-24T10:00:00+08:00',
    fileUrl: '/uploads/follow-up/ld-009-课程介绍.pdf',
    fileName: '课程介绍.pdf',
    createdAt: '2025-10-22T15:00:00+08:00',
    updatedAt: '2025-10-22T15:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
  {
    id: 'fu-013',
    leadId: 'ld-011',
    staffId: 'u-consultant-001',
    staffName: '王顾问',
    method: 'WECHAT',
    content: '体验课结束后微信回访，家长反馈孩子很喜欢，询问套餐价格。',
    nextFollowUpAt: '2025-10-19T10:00:00+08:00',
    createdAt: '2025-10-15T15:00:00+08:00',
    updatedAt: '2025-10-15T15:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
  {
    id: 'fu-014',
    leadId: 'ld-011',
    staffId: 'u-consultant-001',
    staffName: '王顾问',
    method: 'VISIT',
    content: '体验课后家长表示满意，正在考虑报名体能套餐。',
    nextFollowUpAt: '2025-10-20T14:00:00+08:00',
    fileUrl: '/uploads/follow-up/ld-011-体验课照片.jpg',
    fileName: '体验课照片.jpg',
    createdAt: '2025-10-16T17:00:00+08:00',
    updatedAt: '2025-10-16T17:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
  {
    id: 'fu-015',
    leadId: 'ld-012',
    staffId: 'u-principal-001',
    staffName: '李校长',
    method: 'CALL',
    content: '电话沟通年度会员方案，学员表示需要考虑。',
    nextFollowUpAt: '2025-09-25T10:00:00+08:00',
    createdAt: '2025-09-20T10:00:00+08:00',
    updatedAt: '2025-09-20T10:00:00+08:00',
    createdBy: 'u-principal-001',
    updatedBy: 'u-principal-001',
  },
  {
    id: 'fu-016',
    leadId: 'ld-012',
    staffId: 'u-principal-001',
    staffName: '李校长',
    method: 'VISIT',
    content: '学员确认报名年度会员，现场签约并办卡。',
    nextFollowUpAt: null,
    fileUrl: '/uploads/follow-up/ld-012-签约合同.pdf',
    fileName: '签约合同.pdf',
    createdAt: '2025-10-01T10:00:00+08:00',
    updatedAt: '2025-10-01T10:00:00+08:00',
    createdBy: 'u-principal-001',
    updatedBy: 'u-principal-001',
  },
  {
    id: 'fu-017',
    leadId: 'ld-008',
    staffId: 'u-consultant-001',
    staffName: '王顾问',
    method: 'CALL',
    content: '电话联系，学员表示最近忙暂时无法安排课程。',
    nextFollowUpAt: '2025-08-15T14:00:00+08:00',
    createdAt: '2025-08-10T14:00:00+08:00',
    updatedAt: '2025-08-10T14:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
  {
    id: 'fu-018',
    leadId: 'ld-008',
    staffId: 'u-consultant-001',
    staffName: '王顾问',
    method: 'WECHAT',
    content: '微信跟进无回复，标记为回收。',
    nextFollowUpAt: null,
    createdAt: '2025-08-20T10:00:00+08:00',
    updatedAt: '2025-08-20T10:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
]

export const mockCustomers: Customer[] = [
  {
    id: 'cu-001',
    brandId: 'b-001',
    campusId: 'c-001',
    name: '赵小明',
    phone: '13900000001',
    status: 'MEMBER',
    primaryConsultantId: 'u-consultant-001',
    tags: ['篮球班', '老学员'],
    studentNo: 'STU001',
    className: '篮球班A',
    teacherName: '王教练',
    totalSpentMinor: 465000,
    totalConsumption: 3,
    totalSessions: 8,
    familyGroupId: 'fg-001',
    mentorId: 'u-teacher-001',
    birthday: '2015-03-15',
    gender: 'MALE',
    hobby: '篮球、画画',
    createdAt: '2025-10-05T15:00:00+08:00',
    updatedAt: '2025-10-15T08:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
  {
    id: 'cu-002',
    brandId: 'b-001',
    campusId: 'c-001',
    name: '蒋红',
    phone: '13900000012',
    status: 'MEMBER',
    primaryConsultantId: 'u-principal-001',
    tags: ['年度会员'],
    studentNo: 'STU002',
    className: '足球班B',
    teacherName: '李校长',
    totalSpentMinor: 3600000,
    totalConsumption: 2,
    totalSessions: 5,
    familyGroupId: 'fg-002',
    mentorId: 'u-teacher-002',
    birthday: '2014-08-22',
    gender: 'FEMALE',
    hobby: '足球、阅读',
    createdAt: '2025-10-01T10:00:00+08:00',
    updatedAt: '2025-10-01T10:00:00+08:00',
    createdBy: 'u-principal-001',
    updatedBy: 'u-principal-001',
  },
  {
    id: 'cu-003',
    brandId: 'b-001',
    campusId: 'c-002',
    name: '李东',
    phone: '13900000020',
    status: 'MEMBER',
    primaryConsultantId: 'u-consultant-001',
    tags: ['足球班'],
    studentNo: 'STU003',
    className: '私教体能',
    teacherName: '张教练',
    totalSpentMinor: 1080000,
    totalConsumption: 2,
    totalSessions: 12,
    familyGroupId: 'fg-003',
    mentorId: 'u-teacher-001',
    birthday: '2016-01-10',
    gender: 'MALE',
    hobby: '体能训练、游泳',
    createdAt: '2025-09-10T09:00:00+08:00',
    updatedAt: '2025-10-12T14:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
  {
    id: 'cu-004',
    brandId: 'b-001',
    campusId: 'c-002',
    name: '张玲',
    phone: '13900000021',
    status: 'EXPIRED',
    primaryConsultantId: 'u-principal-001',
    tags: ['游泳班', '休学'],
    studentNo: 'STU004',
    familyGroupId: 'fg-004',
    className: '游泳班',
    teacherName: '赵教练',
    totalSpentMinor: 30000,
    totalConsumption: 0,
    totalSessions: 0,
    mentorId: 'u-teacher-003',
    birthday: '2016-06-05',
    gender: 'FEMALE',
    hobby: '游泳、钢琴',
    createdAt: '2025-08-20T10:00:00+08:00',
    updatedAt: '2025-09-20T10:00:00+08:00',
    createdBy: 'u-principal-001',
    updatedBy: 'u-principal-001',
  },
  {
    id: 'cu-005',
    brandId: 'b-001',
    campusId: 'c-003',
    name: '刘洋',
    phone: '13900000022',
    status: 'MEMBER',
    primaryConsultantId: 'u-principal-001',
    tags: ['体能课', '一对一'],
    studentNo: 'STU005',
    className: '体能班',
    teacherName: '李校长',
    totalSpentMinor: 1200000,
    totalConsumption: 5,
    totalSessions: 15,
    familyGroupId: 'fg-005',
    mentorId: 'u-teacher-002',
    birthday: '2013-11-18',
    gender: 'MALE',
    hobby: '体能课、围棋',
    createdAt: '2025-07-15T08:00:00+08:00',
    updatedAt: '2025-10-18T15:00:00+08:00',
    createdBy: 'u-principal-001',
    updatedBy: 'u-principal-001',
  },
  {
    id: 'cu-006',
    brandId: 'b-001',
    campusId: 'c-003',
    name: '陈静',
    phone: '13900000023',
    status: 'CHURNED',
    primaryConsultantId: 'u-consultant-001',
    tags: ['流失学员'],
    studentNo: 'STU006',
    familyGroupId: 'fg-006',
    className: '游泳班',
    teacherName: '赵教练',
    totalSpentMinor: 600000,
    totalConsumption: 10,
    totalSessions: 10,
    mentorId: 'u-teacher-003',
    birthday: '2015-09-30',
    gender: 'FEMALE',
    hobby: '游泳、舞蹈',
    createdAt: '2025-06-01T10:00:00+08:00',
    updatedAt: '2025-09-01T10:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'system',
  },
  {
    id: 'cu-007',
    brandId: 'b-001',
    campusId: 'c-001',
    name: '杨光',
    phone: '13900000024',
    status: 'NORMAL',
    primaryConsultantId: 'u-consultant-001',
    tags: ['新学员'],
    studentNo: 'STU007',
    familyGroupId: 'fg-007',
    className: '',
    teacherName: '',
    totalSpentMinor: 0,
    totalConsumption: 0,
    totalSessions: 0,
    mentorId: 'u-teacher-001',
    birthday: '2017-04-12',
    gender: 'MALE',
    hobby: '篮球、跑步',
    createdAt: '2025-10-22T08:00:00+08:00',
    updatedAt: '2025-10-22T08:00:00+08:00',
    createdBy: 'system',
    updatedBy: 'system',
  },
  {
    id: 'cu-008',
    brandId: 'b-001',
    campusId: 'c-002',
    name: '黄磊',
    phone: '13900000025',
    status: 'MEMBER',
    primaryConsultantId: 'u-principal-001',
    tags: ['足球班', '续费'],
    studentNo: 'STU008',
    className: '足球班B',
    teacherName: '李校长',
    totalSpentMinor: 660000,
    totalConsumption: 2,
    totalSessions: 6,
    familyGroupId: 'fg-002',
    mentorId: 'u-teacher-002',
    birthday: '2014-12-08',
    gender: 'MALE',
    hobby: '足球、画画',
    createdAt: '2025-09-25T09:00:00+08:00',
    updatedAt: '2025-10-19T16:00:00+08:00',
    createdBy: 'u-principal-001',
    updatedBy: 'u-principal-001',
  },
]
